/**
 * A cursor belongs to the exact query that produced it. Saved-view filters and
 * sort order can change without remounting ListView; carrying page 3 into that
 * new result set would skip its first 1,000 governed rows (#882).
 */
export interface PageCursor {
  queryKey: string
  offset: number
}

export function pageOffset(cursor: PageCursor, queryKey: string): number {
  return cursor.queryKey === queryKey ? Math.max(0, cursor.offset) : 0
}

export function movePage(queryKey: string, offset: number): PageCursor {
  return { queryKey, offset: Math.max(0, offset) }
}
